import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSidebarFloating: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="sidebar-floating, floating-window"><path d="M21.25 4.75H2.75V19.25H21.25V4.75Z" stroke="currentColor" strokeWidth="1.5"/><rect x="14.5" y="10.5" width="4" height="6" fill="currentColor"/></CentralIconBase>;
};

export default IconSidebarFloating;
